import type { ModalWorkOrder } from "@/shared/work-orders-modals/models/ModalWorkOrder";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_VALUES_MODAL } from "../../../shared/work-orders-modals/models/ModalInitialValue";
import type { Asset } from "../models/Asset";
import type { WorkOrderAttachment } from "../models/WorkOrderAttachment";

// UI state only. The filters are read from the URL (`hooks/useWorkOrdersFilters.ts`) and the rows
// come from React Query (`hooks/useWorkOrders.ts`), so neither lives here any more.

const WorkOrdersInitialState: {
	assetList: Asset[];

	modalWorkOrderSelected: ModalWorkOrder;

	loaderTable: boolean;

	currenAssetId: string | undefined;

	assetCodes: any;

	allAssets: Asset[];

	listWorkOrderSelected: any[];

	showDialogToCloseGroup: boolean;

	commentCloseGroupWO: string;

	dataToCloseWOGroup: any[];

	openDialogLinkAttachmentToWo: boolean;

	listWorkOrderAttachments: WorkOrderAttachment[];

	allWorkOrderAttachmentsRowsLoading: boolean;

	openDialogRemoveWorkOrderAttachments: boolean;

	workOrderSelectedId: number | null;

	workOrderSelectedName: string | null;

	listWorkOrderAttachmentsSelected: any[];

	workOrderAttachmentSelected: any;

	selectedFilesToAdd: File[];

	attachmentsToAddToWorkOrder: any;

	addAttachmentsFromVeiwer: boolean;

	displayViewerAttachment: boolean;

	attachmentSelected: WorkOrderAttachment | null;

	openWorkOrderResources: boolean;
} = {
	listWorkOrderSelected: [],

	assetList: [],

	modalWorkOrderSelected: INITIAL_VALUES_MODAL,

	loaderTable: false,

	currenAssetId: undefined,

	allAssets: [],

	assetCodes: {},

	showDialogToCloseGroup: false,

	commentCloseGroupWO: "",

	dataToCloseWOGroup: [],

	openDialogLinkAttachmentToWo: false,

	openWorkOrderResources: false,

	listWorkOrderAttachments: [],

	allWorkOrderAttachmentsRowsLoading: false,

	openDialogRemoveWorkOrderAttachments: false,

	workOrderSelectedId: null,

	workOrderSelectedName: null,

	listWorkOrderAttachmentsSelected: [],

	workOrderAttachmentSelected: [],

	selectedFilesToAdd: [],

	attachmentsToAddToWorkOrder: [],

	addAttachmentsFromVeiwer: false,

	displayViewerAttachment: false,

	attachmentSelected: null,
};

export const WorkOrdersReducer = createSlice({
	name: "__",
	initialState: WorkOrdersInitialState,
	reducers: {
		setListWorkOrderSelected(state, { payload }) {
			state.listWorkOrderSelected = payload;
		},

		setOpenDialogLinkAttachmentToWO(state, { payload }) {
			state.openDialogLinkAttachmentToWo = payload;
		},

		setOpenWorkOrderResources(state, { payload }) {
			state.openWorkOrderResources = payload;
		},
		setAssetList(state, { payload }) {
			state.assetList = payload;
		},

		// ================= Modal WorkOrder =====================
		// check this same as next
		setmodalWorkOrderSelected(state, { payload }) {
			state.modalWorkOrderSelected.Comments = payload;
		},

		setComments(state, { payload }) {
			state.modalWorkOrderSelected.Comments = payload;
		},
		setTemplateTitle(state, { payload }) {
			state.modalWorkOrderSelected.TemplateTitle = payload;
		},
		setWorkOrderPlannedHours(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderPlannedHours = payload;
		},
		setWorkOrderNumberOfWorkers(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderNumberOfWorkers = payload;
		},
		setWorkOrderOpenedBy(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderOpenedBy = payload;
		},
		setOpenTimestamp(state, { payload }) {
			state.modalWorkOrderSelected.OpenTimestamp = payload;
		},
		setWorkOrderName(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderName = payload;
		},
		setTitle(state, { payload }) {
			state.modalWorkOrderSelected.Title = payload;
		},
		setAssetName(state, { payload }) {
			state.modalWorkOrderSelected.AssetName = payload;
		},
		setWorkOrderId(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderId = payload;
		},

		setAssetId(state, { payload }) {
			state.modalWorkOrderSelected.AssetId = payload;
		},
		setDownHours(state, { payload }) {
			state.modalWorkOrderSelected.DownHours = payload;
		},
		setCraftId(state, { payload }) {
			state.modalWorkOrderSelected.CraftId = payload;
		},
		setWorkOrderStatusCode(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderStatusCode = payload;
		},

		setLoaderTableWorkOrders(state, { payload }) {
			state.loaderTable = payload;
		},
		setCurrentAssetId(state, { payload }) {
			state.currenAssetId = payload;
		},

		setCommentCloseGroupWO(state, { payload }) {
			state.commentCloseGroupWO = payload;
		},

		setDataToCloseWOGroup(state, { payload }) {
			state.dataToCloseWOGroup = payload;
		},

		// ====================================
		setallAssets(state, { payload }) {
			state.allAssets = payload;
		},

		setAssetCodes(state, { payload }) {
			state.assetCodes = payload;
		},

		setShowDialogToCloseGroup(state, { payload }) {
			state.showDialogToCloseGroup = payload;
		},

		setListWorkOrderAttachments(state, { payload }) {
			state.listWorkOrderAttachments = payload;
		},
		setAllWorkOrderAttachmentsRowsLoading(state, { payload }) {
			state.allWorkOrderAttachmentsRowsLoading = payload;
		},
		setWorkOrderSelectedId(state, { payload }) {
			state.workOrderSelectedId = payload;
		},
		setWorkOrderSelectedName(state, { payload }) {
			state.workOrderSelectedName = payload;
		},
		setOpenDialogRemoveWorkOrderAttachments(state, { payload }) {
			state.openDialogRemoveWorkOrderAttachments = payload;
		},
		setListWorkOrderAttachmentsSelected(state, { payload }) {
			state.listWorkOrderAttachmentsSelected = payload;
		},
		setWorkOrderAttachmentSelected(state, { payload }) {
			state.workOrderAttachmentSelected = payload;
		},
		setSelectedFilesToAdd(state, { payload }) {
			state.selectedFilesToAdd = payload;
		},
		setAttachmentsToAddToWorkOrder(state, { payload }) {
			state.attachmentsToAddToWorkOrder = payload;
		},
		setAddAttachmentsFromVeiwer(state, { payload }) {
			state.addAttachmentsFromVeiwer = payload;
		},
		setDisplayViewerAttachment(state, { payload }) {
			state.displayViewerAttachment = payload;
		},
		setAttachmentSelected(state, { payload }) {
			state.attachmentSelected = payload;
		},
	},
});
